export const LinkContentColumn = [
    {
        id: "name",
        label: "Name",
        style: { custom: { flex: 1 } },
        disabled: true,
        checked: true,
        sortable: true,
        useInAutocomplete: true,
    },
];
